export default "__VITE_ASSET__e6cecb98__"